// Central navigation configuration.
// `label` is a translation key resolved via the language dictionary (nav.*).
export const MAIN_NAV = [
  { key: "procedures", to: "/procedures", label: "nav.procedures" },
  { key: "choosing", to: "/how-to-choose-a-plastic-surgeon-in-vietnam", label: "nav.choosing" },
  { key: "safety", to: "/plastic-surgery-safety-vietnam", label: "nav.safety" },
  { key: "costs", to: "/plastic-surgery-cost-vietnam", label: "nav.costs" },
  { key: "revision", to: "/revision-plastic-surgery-vietnam", label: "nav.revision" },
  { key: "journey", to: "/patient-journey", label: "nav.journey" },
  { key: "guides", to: "/guides", label: "nav.guides" },
  { key: "about", to: "/about", label: "nav.about" },
];

// Links shown in the footer's brand column.
export const FOOTER_MAIN = [
  { key: "about", to: "/about", label: "nav.about" },
  { key: "contact", to: "/contact", label: "nav.contact" },
  { key: "journey", to: "/patient-journey", label: "nav.journey" },
  { key: "results", to: "/results", label: "nav.results" },
  { key: "editorial", to: "/editorial-policy", label: "nav.editorial" },
];

export const FOOTER_PROCEDURES = [
  { to: "/face-surgery-vietnam", label: "Face Surgery" },
  { to: "/nose-surgery-vietnam", label: "Nose Surgery" },
  { to: "/breast-surgery-vietnam", label: "Breast Surgery" },
  { to: "/body-contouring-vietnam", label: "Body Contouring" },
  { to: "/revision-plastic-surgery-vietnam", label: "Revision Surgery" },
];

export const FOOTER_GUIDES = [
  { to: "/is-plastic-surgery-in-vietnam-safe", label: "Is Plastic Surgery in Vietnam Safe?" },
  { to: "/how-to-choose-a-plastic-surgeon-in-vietnam", label: "How to Choose a Surgeon" },
  { to: "/how-to-check-a-plastic-surgeon-licence-vietnam", label: "How to Check a Licence" },
  { to: "/plastic-surgery-vietnam-vs-thailand", label: "Vietnam vs Thailand" },
  { to: "/plastic-surgery-vietnam-vs-south-korea", label: "Vietnam vs South Korea" },
  { to: "/how-long-to-stay-in-vietnam-after-surgery", label: "How Long to Stay" },
];

export const FOOTER_LEGAL = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms" },
  { to: "/medical-disclaimer", label: "Medical Disclaimer" },
  { to: "/image-consent-policy", label: "Image Consent Policy" },
  { to: "/cookie-policy", label: "Cookie Policy" },
];
